import React, { useEffect, useRef, useState } from 'react';
import { ArrowRight, CheckCircle2 } from 'lucide-react';
import { sessionSteps } from '../mock';

const HowItWorksSection = () => {
  const [activeStep, setActiveStep] = useState(0);

  return (
    <section
      id="how-it-works"
      className="py-24 relative overflow-hidden"
      style={{ background: '#2e6abf' }}
    >
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2
            className="text-4xl md:text-5xl font-bold mb-6"
            style={{ fontFamily: 'Merriweather, serif', color: '#F6F6F6' }}
          >
            How a Session Works
          </h2>
          <p
            className="text-lg md:text-xl max-w-2xl mx-auto"
            style={{ color: '#D6E4F0' }}
          >
            Simple, safe, and guided every step of the way
          </p>
        </div>

        {/* Visual flow with image */}
        <div className="grid md:grid-cols-2 gap-12 items-center mb-16">
          <div className="relative">
            <div className="relative rounded-3xl overflow-hidden shadow-2xl border-2 border-white/10">
              <img
                src="https://images.unsplash.com/photo-1758686254024-f0cf710c54d6"
                alt="Elderly couple engaging in a warm video call"
                className="w-full h-full object-cover"
                style={{ aspectRatio: '4/3' }}
              />
              <div
                className="absolute inset-0"
                style={{
                  background: 'linear-gradient(180deg, transparent 50%, #16317266 100%)'
                }}
              />
            </div>

            {/* Floating indicator */}
            <div
              className="absolute -bottom-4 -right-4 p-4 rounded-2xl shadow-xl"
              style={{
                background: 'rgba(255, 255, 255, 0.95)',
                backdropFilter: 'blur(12px)'
              }}
            >
              <div className="flex items-center space-x-2">
                <CheckCircle2 className="w-5 h-5" style={{ color: '#1E56A0' }} />
                <span className="text-sm font-semibold" style={{ color: '#163172' }}>Safe & Monitored</span>
              </div>
            </div>
          </div>

          <div className="space-y-6">
            {sessionSteps.map((step, index) => (
              <div
                key={index}
                className={`p-6 rounded-2xl cursor-pointer ${activeStep === index ? 'shadow-lg border-[#1E56A0]' : 'shadow-sm border-white/5'
                  }`}
                style={{
                  background: activeStep === index
                    ? 'linear-gradient(135deg, #1E56A0 0%, #163172 100%)'
                    : 'rgba(255, 255, 255, 0.05)',
                  border: `2px solid ${activeStep === index ? '#1E56A0' : 'rgba(255, 255, 255, 0.1)'}`,
                }}
                onMouseEnter={() => setActiveStep(index)}
              >
                <div className="flex items-start space-x-4">
                  <div
                    className="flex-shrink-0 w-12 h-12 rounded-full flex items-center justify-center font-bold text-lg"
                    style={{
                      background: activeStep === index
                        ? '#F6F6F6'
                        : 'rgba(214, 228, 240, 0.2)',
                      color: activeStep === index ? '#163172' : '#D6E4F0'
                    }}
                  >
                    {step.step}
                  </div>
                  <div className="flex-1">
                    <h3 className="text-xl font-semibold mb-2" style={{ color: '#F6F6F6' }}>
                      {step.title}
                    </h3>
                    <p style={{ color: '#D6E4F0' }}>
                      {step.description}
                    </p>
                  </div>
                  {activeStep === index && (
                    <ArrowRight className="flex-shrink-0 w-5 h-5" style={{ color: '#F6F6F6' }} />
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Session duration and frequency */}
        <div
          className="text-center p-8 rounded-2xl"
          style={{
            background: 'rgba(214, 228, 240, 0.1)',
            border: '1px solid rgba(214, 228, 240, 0.2)'
          }}
        >
          <p className="text-lg" style={{ color: '#D6E4F0' }}>
            <span className="font-semibold text-[#F6F6F6]">Sessions are 30-45 minutes</span>, scheduled at times that work for everyone.
            Many families choose <span className="font-semibold text-[#F6F6F6]">2-3 sessions per week</span> for
            consistency and routine.
          </p>
        </div>
      </div>
    </section>
  );
};

export default HowItWorksSection;
